export function isIosOrAndroid(platform: string): platform is 'ios' | 'android' {
  return platform === 'ios' || platform === 'android';
}
